import { memo } from 'react';
import { Grid, PanelContent } from '@uniqkey-frontend/shared-app';
import GroupDetailsWidget from '../GroupDetailsWidget';
import GroupDetailsSecurityScoreWidget from '../GroupDetailsSecurityScoreWidget';

interface IGroupDetailsTabProps {
  groupId: string;
}

const GroupDetailsTab = (props: IGroupDetailsTabProps) => {
  const { groupId } = props;

  return (
    <PanelContent p={3} pt={1} className="height-100-percent">
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <GroupDetailsWidget groupId={groupId} />
        </Grid>
        <Grid item xs={6}>
          <GroupDetailsSecurityScoreWidget groupId={groupId} />
        </Grid>
      </Grid>
    </PanelContent>
  );
};

export default memo(GroupDetailsTab);
